<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Ventas</h6>

            <div class="row align-items-end">
              <!-- Columna de búsqueda -->
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar venta..." @input="fetchData(null)" />
              </div>
              <div class="col-md-8 mb-3 text-end ">
                <label class="mb-1 d-block invisible">Acción</label>
                <router-link :to="{ name: 'Remissions Create' }" class="btn btn-sm btn-primary ms-2 mb-1"
                  data-toggle="tooltip" data-original-title="Agregar venta">
                  <i class="fa fa-plus me-1"></i> Agregar venta
                </router-link>
              </div>
            </div>

          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      N°</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Nombre</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Email</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Teléfono</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Observación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Total</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Fecha</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.email }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <h6 class="mb-0 text-sm">{{ value.phone }}</h6>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm" :class="value.status == 1 ? 'bg-success' : 'bg-warning'">
                        {{ value.status == 1 ? 'Formalizada' : 'Pendiente' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2, maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.created_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <!-- Si está formalizada, solo mostrar imprimir y ver -->
                      <template v-if="value.status == 1">
                        <a
                          @click="openTicket(value)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip"
                          data-original-title="Ver ticket"
                        >
                          <i class="fas fa-receipt"></i>
                        </a>
                        
                        <router-link
                          :to="{ name: 'Remissions Create', params: { data: JSON.stringify(value) }, props: true }"
                          class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                          data-original-title="Ver venta" style="margin-left: 15px;">
                          <i class="fa fa-eye"></i>
                        </router-link>
                      </template>
                      
                      <!-- Si está pendiente, mostrar todas las opciones -->
                      <template v-else>
                        <a
                          @click="openTicket(value)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip"
                          data-original-title="Ver ticket"
                        >
                          <i class="fas fa-receipt"></i>
                        </a>
                        
                        <router-link
                          :to="{ name: 'Remissions Create', params: { data: JSON.stringify(value) }, props: true }"
                          class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                          data-original-title="Editar Registro" style="margin-left: 15px;">
                          <i class="fa fa-pencil-alt"></i>
                        </router-link>

                        <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                          style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                      </template>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="9" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters('remissions', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.remissions.currentPage;
    },
    lastPage() {
      return this.$store.state.remissions.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['remissions/links'];
    },
  },
  methods: {
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('remissions/fetchData', params);
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissions/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    formatTicketMoney(value) {
      return Number(value || 0).toLocaleString('es-CO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    async openTicket(remission) {
      try {
        const detailResponse = await this.$store.dispatch('remissionsDetails/getData', remission.id);
        const details = Array.isArray(detailResponse?.data) ? detailResponse.data : [];
        const detailRows = details.map((item) => {
          const name = item.inventory_id
            ? (item.inventory?.name || item.inventory?.ref || 'Inventario')
            : (item.production_model?.model?.name || item.model?.name || 'Modelo');
          const qty = Number(item.quantity || 0);
          const price = this.formatTicketMoney(item.price);
          const total = this.formatTicketMoney(item.total);
          return `
            <tr>
              <td>${name}</td>
              <td class="text-right">${qty}</td>
              <td class="text-right">$${price}</td>
              <td class="text-right">$${total}</td>
            </tr>
          `;
        }).join('');

        const totalGeneral = details.length
          ? details.reduce((acc, item) => acc + Number(item.total || 0), 0)
          : Number(remission.total || 0);

        const ticketWindow = window.open('', '_blank');
        if (!ticketWindow) {
          Swal.fire({
            icon: 'warning',
            title: 'Ventana bloqueada',
            text: 'Permite las ventanas emergentes para ver el ticket.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        const dateText = remission.created_at
          ? new Date(remission.created_at).toLocaleString('es-CO')
          : new Date().toLocaleString('es-CO');

        ticketWindow.document.write(`
          <!DOCTYPE html>
          <html lang="es">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Ticket Venta #${remission.id}</title>
            <style>
              * { box-sizing: border-box; }
              body { margin: 0; padding: 10px; font-family: Arial, sans-serif; background: #f5f5f5; }
              .ticket {
                width: 100mm;
                max-width: 100mm;
                margin: 0 auto;
                background: #fff;
                color: #000;
                padding: 12px;
                border: 1px solid #ddd;
              }
              .title { text-align: center; font-weight: 700; margin-bottom: 8px; }
              .meta { font-size: 12px; line-height: 1.4; margin-bottom: 8px; }
              table { width: 100%; border-collapse: collapse; font-size: 11px; }
              th, td { border-bottom: 1px dashed #ccc; padding: 4px 0; vertical-align: top; }
              th { text-align: left; }
              .text-right { text-align: right; white-space: nowrap; }
              .total { margin-top: 8px; font-size: 13px; font-weight: 700; text-align: right; }
              .actions {
                width: 100mm;
                max-width: 100mm;
                margin: 12px auto 0;
                display: flex;
                gap: 8px;
              }
              .btn {
                flex: 1;
                border: none;
                padding: 8px 10px;
                border-radius: 6px;
                cursor: pointer;
                color: #fff;
                font-weight: 600;
              }
              .btn-close { background: #6c757d; }
              .btn-print { background: #2dce89; }
              @media print {
                body { background: #fff; padding: 0; }
                .ticket { border: none; width: 100mm; max-width: 100mm; margin: 0 auto; }
                .actions { display: none; }
              }
            </style>
          </head>
          <body>
            <div class="ticket">
              <div class="title">TICKET DE VENTA</div>
              <div class="meta">
                <div><strong>Nro:</strong> ${remission.id}</div>
                <div><strong>Fecha:</strong> ${dateText}</div>
                <div><strong>Cliente:</strong> ${remission.name || 'Cliente no definido'}</div>
                <div><strong>Email:</strong> ${remission.email || 'N/A'}</div>
                <div><strong>Teléfono:</strong> ${remission.phone || 'N/A'}</div>
                <div><strong>Observación:</strong> ${remission.observation || 'Sin observación'}</div>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Producto</th>
                    <th class="text-right">Cant.</th>
                    <th class="text-right">Precio</th>
                    <th class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  ${detailRows || '<tr><td colspan="4">Sin productos</td></tr>'}
                </tbody>
              </table>
              <div class="total">TOTAL: $${this.formatTicketMoney(totalGeneral)}</div>
            </div>
            <div class="actions">
              <button class="btn btn-close" onclick="window.close()">Cerrar</button>
              <button class="btn btn-print" onclick="window.print()">Imprimir</button>
            </div>
          </body>
          </html>
        `);
        ticketWindow.document.close();
      } catch (error) {
        console.error("Error al abrir ticket:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No fue posible abrir el ticket de la venta.',
        });
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}
</style>
